import { z } from 'zod'

import type {
  CommonResponseCollectionStudentGroupResponse,
  CommonResponseListAttendanceResponse,
  CommonResponseListGroupedAttendanceResponse,
} from '~/api-spec/__generated__/main'
import { parseApiResponse } from '~/schema/apiBoundary'

import {
  type Attendance,
  AttendanceSchema,
  type DateAttendances,
  DateAttendancesSchema,
  type StudentAttendanceGroup,
  StudentAttendanceGroupSchema,
} from './schemas'

// 생성 타입은 입실·퇴실 시각을 optional 로 그리지만 서버는 키를 빼지 않는다(미퇴실이면 퇴실 시각을 null 로 싣는다).
// 2026-10-14 백엔드 develop(6a0f8e7bb) 의 attendance/controller/response/AttendanceResponse.kt·
// GroupedAttendanceResponse.kt·model/dto/AttendanceDto.kt 로 확인.
const asWire = (
  raw:
    | CommonResponseListAttendanceResponse['data']
    | CommonResponseListGroupedAttendanceResponse['data'],
): unknown => raw

export const adaptAttendances = (raw: CommonResponseListAttendanceResponse['data']): Attendance[] =>
  parseApiResponse(z.array(AttendanceSchema), asWire(raw), 'Attendance')

export const adaptDateAttendances = (
  raw: CommonResponseListGroupedAttendanceResponse['data'],
): DateAttendances[] => parseApiResponse(z.array(DateAttendancesSchema), asWire(raw), 'Attendance')

// 생성 타입은 그룹 멤버를 공통 베이스(id·name)로만 그린다. 실제로는 하위 클래스
// StudentMemberWithAttendanceResponse 가 직렬화되어 email·attendance 가 함께 온다.
// 2026-10-14 백엔드 develop(6a0f8e7bb) 의 student/controller/response/StudentMemberResponse.kt 로 확인.
const asGroupWire = (raw: CommonResponseCollectionStudentGroupResponse['data']): unknown => raw

export const adaptStudentAttendanceGroups = (
  raw: CommonResponseCollectionStudentGroupResponse['data'],
): StudentAttendanceGroup[] =>
  parseApiResponse(z.array(StudentAttendanceGroupSchema), asGroupWire(raw), 'Attendance')
